let routes = [
  {
    path: '/admin',
    name: 'admin',
    component: () => import('./components/AdminMain.vue')
  }
]

export default routes
